import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-695cb78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = {
  key: 1,
  class: "modal"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  alt: "close",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "collapsible-content embed-responsive embed-responsive-16by9" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:moodbuster.fgb@vu.nl" }, "moodbuster.fgb@vu.nl", -1))
const _hoisted_26 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showHelpModal)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showHelpModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showHelpModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("HEADER.HELP.TITLE")), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    (_ctx.treatmentSet)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createTextVNode(_toDisplayString(_ctx.$t("HOME.SENTENCE_1", { number: _ctx.numberOfModules })) + " " + _toDisplayString(_ctx.$t("HOME.SENTENCE_2")) + " ", 1),
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.SENTENCE_3")) + " ", 1),
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.SENTENCE_4")) + " ", 1),
                          _hoisted_11,
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HEADER.HELP.URGENT")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.treatmentSet)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                          _createTextVNode(_toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")) + " ", 1),
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")) + " ", 1),
                          _hoisted_15,
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HEADER.HELP.URGENT")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_17,
                  (_ctx.manualsPath?.website != null || _ctx.manualsPath?.app != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t("HEADER.HELP.MANUALS.TITLE")) + ":", 1),
                        _createElementVNode("ul", null, [
                          (_ctx.manualsPath?.website != null)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                _createElementVNode("a", {
                                  href: _ctx.manualsPath.website,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.$t("HEADER.HELP.MANUALS.WEBSITE")), 9, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.manualsPath?.app != null)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                _createElementVNode("a", {
                                  href: _ctx.manualsPath.app,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.$t("HEADER.HELP.MANUALS.APP")), 9, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandCollapsible($event))),
                              class: "collapsible"
                            }, _toDisplayString(_ctx.$t("HEADER.HELP.MANUALS.VIDEO")), 1),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("iframe", {
                                width: "640",
                                height: "360",
                                style: {"max-width":"100%","max-height":"100%","border":"none"},
                                src: _ctx.manualsPath.video,
                                frameborder: "0",
                                allowFullScreen: "true",
                                webkitallowfullscreen: "true",
                                mozallowfullscreen: "true",
                                allow: "autoplay",
                                scrolling: "no"
                              }, "\n                  iFrame is not supported!\n                ", 8, _hoisted_24)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t("HEADER.HELP.TECH.TITLE")) + ":", 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("HEADER.HELP.TECH.TEXT")) + ": ", 1),
                      _hoisted_25,
                      _createTextVNode(". ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("HEADER.HELP.VERSION")) + ": " + _toDisplayString(_ctx.version), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}